import React from "react";
import { Box, Typography } from "@mui/material";
import AppButton from "../buttons/AppButton";

const PageError = ({ error, onClick }) => {
  return (
    <Box
      display="flex"
      flexDirection="column"
      justifyContent="center"
      alignItems="center"
      textAlign="center"
      mt={5}
    >
      <Typography color="error" variant="h6">
        {error}
      </Typography>

      <AppButton
        onClick={onClick}
        variant="outlined"
        color="error"
        sx={{ mt: 2 }}
      >
        Retry
      </AppButton>
    </Box>
  );
};

export default PageError;
